import React, { useState } from 'react';

interface GeolocationWarningProps {
  geolocationAllowed: boolean;
  translations?: Record<string, string>;
}

const GeolocationWarning: React.FC<GeolocationWarningProps> = ({ geolocationAllowed, translations = {} }) => {
  const [showHelp, setShowHelp] = useState(false);

  if (geolocationAllowed) return null;

  const t = (key: string, fallback: string) => translations[key] || fallback;

  return (
    <div className="geolocation-warning">
      <p className="geolocation-warning-text">
        ⚠️ {t('place.geolocationDenied', 'You need to allow browser geolocation, otherwise geolocation features may work inaccurately.')}
        {' '}
        <button
          type="button"
          className="geolocation-warning-btn-link"
          onClick={() => setShowHelp((s) => !s)}
        >
          {showHelp
            ? t('place.geolocationHideHelp', 'Hide instructions')
            : t('place.geolocationHowTo', 'How to enable')}
        </button>
      </p>
      {showHelp && (
        <ul className="geolocation-warning-help">
          <li>{t('place.geolocationHelpChrome', 'Chrome/Edge: click the lock icon left of the URL → Site settings → Location → Allow.')}</li>
          <li>{t('place.geolocationHelpFirefox', 'Firefox: click the lock icon → Connection secure → More information → Permissions → Access Your Location → Allow.')}</li>
          <li>{t('place.geolocationHelpSafari', 'Safari: Safari menu → Settings → Websites → Location → set this site to Allow.')}</li>
          <li>{t('place.geolocationHelpReload', 'After allowing, reload the page.')}</li>
        </ul>
      )}
    </div>
  );
};

export default GeolocationWarning;
